/* eslint-disable no-console */
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { IToast } from '../models';

@Injectable({ providedIn: 'root' })
export class ToastService {
  public get toastFeed$() {
    return this.toasts$.asObservable();
  }

  private toasts: IToast[];
  private toasts$: BehaviorSubject<IToast[]>;

  constructor() {
    this.toasts = [];
    this.toasts$ = new BehaviorSubject(this.toasts);
  }

  public push(toast: IToast) {
    this.toasts.push(toast);
    this.toasts$.next(this.toasts);
  }

  public popIndex(index: number) {
    this.toasts.splice(index, 1);
    this.toasts$.next(this.toasts);
  }

  public success(message: string, timeout = 5 * 1000) {
    console.log('pushing with message:', message);
    this.push({
      alertLevel: 'success',
      heading: 'Success',
      body: message,
      timeout,
    });
  }

  public error(message: string, timeout = 10 * 1000) {
    console.log('pushing with error:', message);

    this.push({
      alertLevel: 'danger',
      heading: 'Error',
      body: message,
      timeout,
    });
  }

  public showToast(success: boolean, message: string) {
    if (success) {
      this.push({
        alertLevel: 'success',
        heading: 'Success',
        body: message,
        timeout: 10 * 1000,
      });
    } else {
      this.push({
        alertLevel: 'danger',
        heading: 'Error',
        body: message,
        timeout: 0,
      });
    }
  }
}
